export const paths = {
  membersOnly: '/content/members-only',
  allContent: '/content/all-content',
};
